import { render, staticRenderFns } from "./WarehouseLoad.vue?vue&type=template&id=7227d4b7&"
import script from "./WarehouseLoad.vue?vue&type=script&lang=js&"
export * from "./WarehouseLoad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports